import { NumberInput } from '@iterable/deprecated_react_components';
import noop from 'utils/noop';
import { StyledFormField } from './styles';

// type Props = {
//   /** Label of the amount input. */
//   label: string,
//   /** Callback function when value changes. */
//   onChange: ({}, { value: string }) => void,
//   /** The value of the amount. */
//   value: string,
// };

const AmountInput = ({ label = 'Amount', onChange = noop, value, ...otherProps }) => {
  return (
    <StyledFormField labelText={label} {...otherProps}>
      <NumberInput allowNegative={false} onChange={onChange} value={value} />
    </StyledFormField>
  );
};

export default AmountInput;
